import React, {
  useState,
  useEffect,
  useRef,
  useImperativeHandle,
  forwardRef,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showModal } from '@store/actions/commonAction';
import { verifyAuthNoFail } from '@store/actions/userAction';

import Timer from '@components/common/Timer';
import SatButton from '@components/common/satUI/SatButton';
import SatModal from '@components/common/satUI/SatModal';
import SatNumberKeypad from '@components/common/satUI/SatNumberKeypad';

const CustomerAuthSms = ({
  isOpen,
  customerInfo,
  onRetry,
  onVerify,
  onClose,
}) => {
  const handleClose = () => {
    if (typeof onClose === 'function') onClose();
  };

  const handleVerify = authNo => {
    if (typeof onVerify === 'function') onVerify(authNo);
  };

  const handleRetry = isDone3Minutes => {
    if (typeof onRetry === 'function') onRetry(isDone3Minutes);
  };

  return (
    <SatModal
      visible={isOpen}
      setVisible={handleClose}
      type="slide"
      render={() => (
        <CustomerAuthSmsContent
          cpNo={customerInfo?.mobileTelNo}
          onVerifyAuth={handleVerify}
          onRetryRequest={handleRetry}
          // inputComplete={authInputComplete}
          onClickClose={handleClose}
        />
      )}
    />
  );
};

const CustomerAuthSmsContent = forwardRef((props, ref) => {
  const { cpNo, onVerifyAuth, onRetryRequest } = props;

  const input1Ref = useRef();
  const input2Ref = useRef();
  const input3Ref = useRef();
  const input4Ref = useRef();
  const input5Ref = useRef();
  const input6Ref = useRef();

  const dispatch = useDispatch();
  const {
    authInfo: { authSms },
  } = useSelector(state => state.userReducer);

  const [inputList, setInputList] = useState(null);
  const [timer, setTimer] = useState({ visible: false, error: '' });
  const certiNumber =
    inputList?.map(inputInfo => inputInfo.value).join('') || '';
  const focusIndex = certiNumber.length;

  useImperativeHandle(ref, () => ({
    onBlur() {
      // input6Ref.current?.blur();
      handleBlur(5);
    },
  }));

  useEffect(() => {
    setInputList([
      { ref: input1Ref, value: '' },
      { ref: input2Ref, value: '' },
      { ref: input3Ref, value: '' },
      { ref: input4Ref, value: '' },
      { ref: input5Ref, value: '' },
      { ref: input6Ref, value: '' },
    ]);

    setTimer({ ...timer, visible: true });
  }, []);

  useEffect(() => {
    if (timer.error === 'wrong') {
      dispatch(verifyAuthNoFail({ error: '' }));
    }
    if (inputList && inputList.filter(item => item.value !== '').length === 0) {
      // input1Ref.current?.focus();
      handleFocus(0);
    }
    if (inputList && inputList.filter(item => item.value === '').length === 0) {
      handleVerifyAuth();
    }
  }, [inputList]);

  useEffect(() => {
    if (authSms.error !== '') {
      setTimer({ ...timer, error: authSms.error });
    }
  }, [authSms]);

  const handleFocus = index => {
    // Focus 로직 필요 시 작성
    return;
  };

  const handleBlur = index => {
    // Blur 로직 필요 시 작성
    return;
  };

  const handleClear = () => {
    setInputList(inputList.map(num => ({ ...num, value: '' })));
  };

  const handleChangeNumber = async (number = '') => {
    if (!inputList) return;

    const numbers = number.split('');
    setInputList(
      inputList.map((num, idx) => {
        return { ...num, value: numbers[idx] || '' };
      }),
    );
  };

  const handleRetry = () => {
    if (timer.error !== '') {
      setInputList([
        { ref: input1Ref, value: '' },
        { ref: input2Ref, value: '' },
        { ref: input3Ref, value: '' },
        { ref: input4Ref, value: '' },
        { ref: input5Ref, value: '' },
        { ref: input6Ref, value: '' },
      ]);
      setTimer({ visible: true, error: '' });
      onRetryRequest(true);
    } else {
      setInputList([
        { ref: input1Ref, value: '' },
        { ref: input2Ref, value: '' },
        { ref: input3Ref, value: '' },
        { ref: input4Ref, value: '' },
        { ref: input5Ref, value: '' },
        { ref: input6Ref, value: '' },
      ]);
      setTimer({ visible: false, error: '' });
      setTimeout(
        function () {
          setTimer({ visible: true, error: '' });
        }.bind(this),
        200,
      );
      onRetryRequest(false);
    }
  };

  const handleVerifyAuth = () => {
    if (timer.error === 'timeout') {
      dispatch(
        showModal({
          visible: true,
          type: 'info',
          msg: '유효시간이 초과하였습니다.',
        }),
      );
    } else if (inputList.filter(num => num.value === '').length > 0) {
      dispatch(
        showModal({
          visible: true,
          type: 'info',
          msg: '인증번호를 입력하세요.',
        }),
      );
    } else {
      onVerifyAuth(inputList.map(num => num.value).join(''));
    }
  };

  // const handleKeyDown = (e, index) => {
  //   if (e.keyCode === 8) {
  //     if (index > 0) {
  //       setInputList(
  //         inputList.map((num, idx) => {
  //           return idx === index ? { ...num, value: '' } : num;
  //         }),
  //       );
  //       // inputList[index - 1].ref.current.focus();
  //       handleFocus(index - 1);
  //     }
  //   } else if (e.keyCode === 13) {
  //     if (index < 5) {
  //       // inputList[index].ref.current.focus();
  //       handleFocus(index);
  //     }
  //   } else {
  //     e.preventDefault();
  //   }
  // };

  return (
    <>
      <p className="verification-tit">
        <span className="num">{cpNo}</span>번으로 보내드린
        <br />
        인증번호를 입력해주세요.
      </p>

      {/* verification-num error 일때 className error 추가 */}
      <div className={`verification-num ${timer.error !== '' && 'error'}`}>
        {inputList &&
          inputList.map((number, index) => (
            <input
              readOnly
              key={`inputList-${index}`}
              ref={number.ref}
              type="number"
              value={number.value}
              maxLength={1}
              className={$classNames('input input-wrap', {
                focus: index === focusIndex,
                val: number.value !== '',
              })}
              // className={`input ${number.value !== '' && 'val'}`}
              // onKeyDown={e => handleKeyDown(e, index)}
              // onChange={e => handleChangeNumber(e.target.value, index)}
            />
          ))}
      </div>

      <div className="btn-area">
        {timer.visible && timer.error === '' && (
          <>
            <p className="text-info blue">
              인증코드 유효시간{' '}
              <Timer
                type="min"
                time={180}
                callback={() =>
                  setTimer(prevState => {
                    return {
                      ...prevState,
                      error: 'timeout',
                    };
                  })
                }
              />
            </p>
          </>
        )}
        {timer.error !== '' && (
          <p className="text-info ico-type error">
            {timer.error === 'wrong'
              ? '인증 번호가다릅니다. 다시 시도해주세요.'
              : '유효시간이만료되었습니다. 인증번호 재요청버튼을 눌러 다시 입력하세요.'}
          </p>
        )}
        <SatButton
          label="인증번호 재요청"
          styleClass="btn-s blue side-r"
          onClick={handleRetry}
        />
      </div>

      <div className="btn-area">
        <SatButton
          label="인증번호 확인"
          styleClass="btn-l blue"
          onClick={handleVerifyAuth}
        />
      </div>

      <SatNumberKeypad
        type="number"
        numValue={certiNumber}
        validGuide={''}
        maxLength={inputList?.length || 0}
        onClear={handleClear}
        onChange={value => handleChangeNumber(value)}
        onOk={handleVerifyAuth}
      />
    </>
  );
});

export default CustomerAuthSms;
